module.exports = __webpack_public_path__ + "img/edge_activites_voile.86d65f06.svg";